import fetchUserIsLogged from '~/modules/api/rurality/v3/user/is-logged'

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const handleMessage = async (event: MessageEvent) => {
      if (event.data.type === 'GET_AUTH_STATUS') {
        try {
          const authUserData = await fetchUserIsLogged()

          if (event.source) {
            if (window.cordova_iab) {
              window.cordova_iab.postMessage(
                JSON.stringify({ type: 'AUTH_STATUS', authUserData }),
              )
            } else if (window.webkit?.messageHandlers?.cordova_iab) {
              window.webkit.messageHandlers.cordova_iab.postMessage(
                JSON.stringify({ type: 'AUTH_STATUS', authUserData }),
              )
            }
          }
        } catch (error) {
          console.error('Error checking auth status:', error)
        }
      }
    }

    window.addEventListener('message', handleMessage)

    onBeforeUnmount(() => {
      window.removeEventListener('message', handleMessage)
    })
  }
})
